import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics"
import { Capacitor } from "@capacitor/core"

export const haptic = {
  light: () => {
    if (Capacitor.isNativePlatform()) {
      Haptics.impact({ style: ImpactStyle.Light }).catch(() => {})
    }
  },
  medium: () => {
    if (Capacitor.isNativePlatform()) {
      Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {})
    }
  },
  heavy: () => {
    if (Capacitor.isNativePlatform()) {
      Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {})
    }
  },
  success: () => {
    if (Capacitor.isNativePlatform()) {
      Haptics.notification({ type: NotificationType.Success }).catch(() => {})
    }
  },
  error: () => {
    if (Capacitor.isNativePlatform()) {
      Haptics.notification({ type: NotificationType.Error }).catch(() => {})
    }
  },
  warning: () => {
    if (Capacitor.isNativePlatform()) {
      Haptics.notification({ type: NotificationType.Warning }).catch(() => {})
    }
  },
}
